/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import { Fragment, WrappedSvg } from "../../utilities/hyperapp";
import ShareMenu from "./share-menu";
import AddToQueueButton from "../player-buttons/add-to-queue-button";

import playIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../player/play-icon.svg";
import pauseIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../player/pause-icon.svg";

function labelForType(type, shared) {
  if (shared) {
    return null;
  }
  switch (type) {
    case "broadcast_episode":
      return "episode";
    case "online_episode":
      return "episode";
    case "audio_archive_item":
      return "audio archive";
    case "clip":
      return "segment";
    case "podcast_episode":
      return "podcast";
    default:
      return "item";
  }
}

export default function EpisodePlayer({
  addToQueue,
  elapsedPercentage,
  currentTime,
  duration,
  formattedDuration,
  isCurrentItem,
  isPlaying,
  items,
  shareURL,
  sharedMomentBaseURL,
  pause,
  play,
  playNext
}) {
  const item = items[0];
  // Ensure % is based on current item
  elapsedPercentage = elapsedPercentage || 0;
  if (!isCurrentItem) {
    elapsedPercentage = 0;
  }
  const size = "large";
  const isSharedMoment = item._copy != null;
  return (
    <Fragment>
      <div
        aria-label={`${elapsedPercentage}% played`}
        class="audio-summary__play-progress"
        style={{ width: `${elapsedPercentage}%` }}
      />
      <div class="audio-summary__wrapper">
        <div class="audio-summary__buttons">
          <button
            class={classNames("audio-summary__button", {
              "action--play-active": isPlaying
            })}
            onclick={isPlaying ? pause : play}
            ga-on="click,auxclick,contextmenu"
            ga-event-category="audio"
            ga-event-action="play"
            ga-event-label={item.data.title}
          >
            <div class="audio-summary__play-button action action--large action--play">
              <span class="play-button">
                <WrappedSvg data={playIcon} />
              </span>
              <span class="pause-button">
                <WrappedSvg data={pauseIcon} />
              </span>
            </div>
          </button>
          <AddToQueueButton addToQueue={addToQueue} size={size} item={item} />
        </div>
        <div class="audio-summary__content-inner">
          <span class="audio-summary__title t-bold t-alternate c-grey-darker d-block">
            {isSharedMoment ? "Shared moment from " : "Listen to "}
            {item.data.title}
          </span>
          <span class="audio-summary__meta t-alternate c-grey-darker d-block">
            {formattedDuration}
            <em> ∙ </em>
            {item.data.subtitle}
          </span>
          <span class="audio-summary__actions d-block c-grey-darker clearfix">
            <button
              class="audio-summary__action"
              onclick={playNext}
              ga-on="click,auxclick,contextmenu"
              ga-event-category="audio"
              ga-event-action="play next"
              ga-event-label={item.data.title}
            >
              <span>Play next</span>
            </button>
            <em> ∙ </em>
            {item.data.audio_file_downloadable && (
              <span>
                <button class="audio-summary__action">
                  <span>
                    <a
                      href={item.data.audio_file.path}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </span>
                </button>
                <em> ∙ </em>
              </span>
            )}
            <ShareMenu
              shareURL={shareURL}
              sharedMomentBaseURL={sharedMomentBaseURL}
              label={labelForType(item.type, item._copy != null)}
              title={item.data.title}
              playerItemID={item.player_item_id}
              duration={duration}
              currentTime={isCurrentItem ? currentTime : null}
            />
          </span>
        </div>
      </div>
    </Fragment>
  );
}
